import { UserEmail } from '@feedyou-ai/feedbot-schema'
import { uniq, toLower, camelCase, startCase, capitalize } from 'lodash'

import { IS_VALID_EMAIL } from './regex'
import { isNotEmptyElement } from './array'

export const IS_STRING_BINARY = /^[01]+$/

export function isStringBinary(string: string): boolean {
  return IS_STRING_BINARY.test(string)
}

export function toFirstLetterUpperCase(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function toFirstLetterLowerCase(string: string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export function toFirstLetterUpperCaseAndRestToLowerCase(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export function omitLastChars(str: string, omittedCharCount: number): string {
  return str.slice(0, str?.length - omittedCharCount)
}

export function getLastChars(str: string, charCount: number): string {
  return str.substring(str.length - charCount)
}

export function areGivenStringsEqual(str1: string, str2: string, caseSensitive = false): boolean {
  return caseSensitive
    ? str1?.trim() === str2?.trim()
    : str1?.trim()?.toLowerCase() === str2?.trim()?.toLowerCase()
}

export function isNotEmptyString(string?: string): boolean {
  return isNotEmptyElement(string) && string !== ''
}

export function isNotEmptyStringOrWhiteSpace(string?: string): boolean {
  return isNotEmptyElement(string) && string?.trim() !== ''
}

export function toPascalCase(string: string): string {
  return toFirstLetterUpperCase(camelCase(string))
}

export function isEmptyStringOrWhiteSpace(string: string): boolean {
  return !isNotEmptyStringOrWhiteSpace(string)
}

export function toStartCaseWithFirstLetterUpperCase(string: string): string {
  return capitalize(toLower(startCase(string)))
}

export function replaceLastCharWithNext(string: string): string {
  const lastChar = string[string.length - 1]
  const nextChar = String.fromCharCode(lastChar.charCodeAt(0) + 1)

  return string.slice(0, -1) + nextChar
}

export function removeWhitespaces(string: string): string {
  return string.replace(/\s+/g, '')
}

export function extractEmailsFromCommaSeparatedList(stringifiedList: string): UserEmail[] {
  return uniq(
    stringifiedList
      .split(',')
      .filter(isNotEmptyStringOrWhiteSpace)
      .map(email => email.trim().toLowerCase())
      .filter(email => new RegExp(IS_VALID_EMAIL).test(email))
  )
}
